import {NgModule} from '@angular/core';

import {TreeListComponent} from './index';
import {IonicModule} from 'ionic-angular';
import {RadioTreeNodeModule} from '../tree-node/radio-tree-node/radio-tree-node.component.module';
import {CheckboxTreeNodeModule} from '../tree-node/checkbox-tree-node/checkbox-tree-node.component.module';

/**
 * Module for the TreeListModule
 * @class
 */
@NgModule({
  declarations: [TreeListComponent],
  exports: [TreeListComponent],
  imports: [
    IonicModule,
    CheckboxTreeNodeModule,
    RadioTreeNodeModule,
  ],
  providers: [],
})
export class TreeListModule {
}



// WEBPACK FOOTER //
// ./src/app/shared/components/tree/tree-list/tree-list.component.module.ts